// src/crm/campaigns/rates.ts
// Barème d'estimation UGC — validé par Léo le 2026-08-16 (point médian des
// fourchettes du doc 06-contenu-influence.md §6 ; au-delà de 100k : à négocier).
import type { Creator } from '../../lib/types'

export const RATE_TIERS = [
  { label: 'nano', maxFollowers: 10_000, rate: 175 },
  { label: 'micro', maxFollowers: 100_000, rate: 450 },
] as const

/** Audience de référence : le plus grand nombre de followers parmi les réseaux. */
export function mainFollowers(creator: Creator): number | null {
  const counts = creator.socials
    .map((s) => s.followers)
    .filter((f): f is number => f !== null)
  return counts.length > 0 ? Math.max(...counts) : null
}

/**
 * Tarif estimé : defaultRate s'il est renseigné, sinon barème par audience,
 * sinon null (« à négocier » — au-delà de 100k ou audience inconnue).
 */
export function estimateRate(creator: Creator): number | null {
  if (creator.defaultRate !== null) return creator.defaultRate
  const followers = mainFollowers(creator)
  if (followers === null) return null
  for (const tier of RATE_TIERS) {
    if (followers < tier.maxFollowers) return tier.rate
  }
  return null
}
